import styled from 'styled-components';
import { ImageUtils } from '../../utils/ImageUtils';
import { mobileQuery } from '../../utils';

export const Header = () => {
  return (
    <HeaderContainer>
      <LogoContainer>
        <TopLogo src={ImageUtils.PartnerText} />
        <Logo src={ImageUtils.Logo} />
      </LogoContainer>
      <TableContainer>
        <HeaderRow>
          <HeaderCell></HeaderCell>
          <HeaderCell>
            <HeaderTitle>온라인 새틀라이트</HeaderTitle>
          </HeaderCell>
          <HeaderCell>
            <HeaderTitle>오프라인 이벤트</HeaderTitle>
          </HeaderCell>
        </HeaderRow>
        <Table>
          <colgroup>
            <col style={{ width: '10%' }} />
            <col style={{ width: '53%' }} />
            <col style={{ width: '37%' }} />
          </colgroup>
          <tbody>
            <tr>
              <TableCell1>메인</TableCell1>
              <TableCell1>
                4월 29일(화)-5월 6일(화) <OnlyWeb>/</OnlyWeb>
                <OnlyMobile>
                  <br />
                </OnlyMobile>
                오후 5시, 8시, 11시
              </TableCell1>
              <TableCell1>
                <strong>DAY1</strong> 5월 17일(토)<OnlyWeb>{` `}</OnlyWeb>
                <OnlyMobile>
                  <br />
                </OnlyMobile>
                <strong>DAY2</strong> 5월 18일(일)
              </TableCell1>
            </tr>
            <tr>
              <TableCell1>사이드</TableCell1>
              <TableCell1>
                5월 2일(금)-6일(화) <OnlyWeb>/</OnlyWeb>
                <OnlyMobile>
                  <br />
                </OnlyMobile>{' '}
                오후 6:30분, 9:30분, 오전0:30분 <br />
                <span>(마지막 경기는 5월 7일 0:30분에 진행)</span>
              </TableCell1>
              <TableCell1>5월 16일(금)</TableCell1>
            </tr>
            <tr>
              <TableCell2>장소</TableCell2>
              <TableCell2>피망 쇼다운 홀덤 앱</TableCell2>
              <TableCell2>인천 파라다이스 시티</TableCell2>
            </tr>
          </tbody>
        </Table>
      </TableContainer>
    </HeaderContainer>
  );
};

const TableContainer = styled.div`
  max-width: 820px;
  margin: 0 auto;

  ${mobileQuery} {
    padding-left: 9px;
    padding-right: 9px;
    padding-bottom: 9px;
  }
`;

const HeaderContainer = styled.header``;

const TopLogo = styled.img`
  width: 406px;
  ${mobileQuery} {
    width: 203px;
  }
`;

const Logo = styled.img`
  width: 520px;
  ${mobileQuery} {
    width: 285px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding-top: 28px;
  position: relative;
  margin-bottom: 15px;

  ${mobileQuery} {
    padding-top: 0px;
    margin-bottom: 0px;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
`;

const Table = styled.table`
  width: 100%;
  text-align: left;
  margin-bottom: 25px;
  position: relative;

  ${mobileQuery} {
    margin-bottom: 0px;
  }
`;

const TableCell = styled.td`
  text-align: center;
  background: rgba(0, 0, 0, 0.3);

  font-weight: 400;
  font-size: 18px;
  line-height: 29px;
  letter-spacing: -0.05em;

  color: rgba(255, 255, 255, 0.7);

  ${mobileQuery} {
    font-size: 10px;
    line-height: 16px;
  }
`;

const TableCell1 = styled(TableCell)`
  height: 42px;
  color: #ea91a9;

  strong {
    font-weight: 700;
  }

  span {
    color: #ad6578;
  }
`;

const TableCell2 = styled(TableCell)`
  height: 40px;
  line-height: 40px;
  color: #ea91a9;

  ${mobileQuery} {
    height: 20px;
    line-height: 22px;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  border-collapse: collapse;
`;

const HeaderCell = styled.div`
  background: rgba(187, 69, 99, 0.5);
  border-top: 2px solid rgba(250, 41, 124, 0.8);
  box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.1);
  color: rgba(255, 255, 255, 0.8);
  height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:first-child {
    width: 10%; /* 첫 번째 빈 셀의 너비 조정 */
  }

  &:nth-child(2) {
    width: 53%; /* 두 번째, 세 번째 셀의 너비 */
  }

  &:nth-child(3) {
    width: 37%; /* 두 번째, 세 번째 셀의 너비 */
  }

  ${mobileQuery} {
    height: 18px;
    border-top: 1px solid rgba(250, 41, 124, 0.8);
    box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.1);
  }
`;

const HeaderTitle = styled.h3`
  margin: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  font-size: 16px;

  ${mobileQuery} {
    font-size: 10px;
  }
`;

const OnlyMobile = styled.span`
  display: none;

  ${mobileQuery} {
    display: inline;
  }
`;

const OnlyWeb = styled.span`
  display: inline;

  ${mobileQuery} {
    display: none;
  }
`;
